export enum OAuthProvider {
    Amazon = 'amazon',
    Apple = 'apple',
    Appwrite = 'appwrite',
    Auth0 = 'auth0',
    Authentik = 'authentik',
    Autodesk = 'autodesk',
    Bitbucket = 'bitbucket',
    Bitly = 'bitly',
    Box = 'box',
    Cloudflare = 'cloudflare',
    Dailymotion = 'dailymotion',
    Discord = 'discord',
    Disqus = 'disqus',
    Dropbox = 'dropbox',
    Etsy = 'etsy',
    Facebook = 'facebook',
    Figma = 'figma',
    Fusionauth = 'fusionauth',
    Github = 'github',
    Gitlab = 'gitlab',
    Google = 'google',
    Huggingface = 'huggingface',
    Kakao = 'kakao',
    Keycloak = 'keycloak',
    Kick = 'kick',
    Linkedin = 'linkedin',
    Microsoft = 'microsoft',
    Notion = 'notion',
    Oidc = 'oidc',
    Okta = 'okta',
    Paypal = 'paypal',
    PaypalSandbox = 'paypalSandbox',
    Podio = 'podio',
    Resend = 'resend',
    Salesforce = 'salesforce',
    Slack = 'slack',
    Spotify = 'spotify',
    Stripe = 'stripe',
    Tiktok = 'tiktok',
    Tradeshift = 'tradeshift',
    TradeshiftBox = 'tradeshiftBox',
    Twitch = 'twitch',
    Webflow = 'webflow',
    Wordpress = 'wordpress',
    X = 'x',
    Yahoo = 'yahoo',
    Yammer = 'yammer',
    Yandex = 'yandex',
    Zoho = 'zoho',
    Zoom = 'zoom',
}
